module.exports = __webpack_public_path__ + "static/media/userIcon.99deff5a.svg";